<template>
  <div class="bannerBox">

    <div class="cssBanner">
      <div class="mainContainer">
        <div class="leftContentBox">
          <span>Click & Chop</span>
          <span>Jetso now!</span>
        </div>

      </div>
      <div class="rabbitBg">
        <img
          src="@/assets/images/banner2.jpg"
          class="img-full hidden-xs"
        />
        <img
          src="@/assets/images/banner_mobile.jpg"
          class="img-full visible-xs"
        />
      </div>

    </div>

  </div>
</template>
<script>

export default {
  name: 'CanvasRebbin',
  props: {
    setHeight: {
      type: Function,
      default: null
    }
  },
  data () {
    return {
      indent_style: '',
      validity_period: '05/01/2020 ~ 12/12/2020',
      coupons: [{ couponBannerUrl: '' }],
      cssBannerStyle: {
        url: require('@/assets/images/bg.svg')
      },
      wrapper: {
        url: require('@/assets/images/chop.svg')
      }
    }
  }
  /* mounted() {
     var marqueeTextLength = this.$refs.marqueeText.offsetWidth
     console.log(marqueeTextLength);
       var marquee = document.getElementsByName('marqueeName')
     marquee.forEach(each => {
       var mar = each
       var indent = 0
       mar.marquee = () => {
         indent--
         this.indent_style = 'transform: translate(' + indent + 'px, 0px)'
         if (indent <= (-marqueeTextLength - 1150)) {
           indent = -43
         }
       }
       this.timer = setInterval(mar.marquee, 1000 / 100)
     })
   },
   destroyed () {
     clearInterval(this.timer)
   }, */
}
</script>
<style scoped>
.cssBanner {
  color: white;
  position: relative;
}

.mainContainer {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  -ms-transform: translateX(-50%) translateY(-50%);
  -webkit-transform: translateX(-50%) translateY(-50%);
  max-width: 1280px;
  width: 100%;
}

.leftContentBox {
  font-family: "Poppins", "Noto Sans TC", sans-serif, "Microsoft JhengHei",
    "Microsoft Yahei", "Hiragino Sans GB";
  padding: 0 15px;
  font-weight: 800;
  font-size: 3.5em;
  text-align: left;
  color: #ffffff;
  position: relative;
}
.leftContentBox span {
  display: block;
  line-height: 1;
}
.rabbitBox {
  margin-right: -40px;
}
.rabbitBox img {
  width: 90%;
}
.h1 {
  font-size: 3.5em;
}
.text-wrapper {
  padding: 20vh 0 0;
}
.data_detail {
  position: relative;
  width: 100%;
}

@media (max-width: 767px) {
  .site-core .slogan {
    display: none;
  }
  .leftContentBox {
    font-size: 1.38em;
  }
  .slogan2 {
    display: none;
  }
  .leftContentBox {
    width: 100%;
    margin: 20px 0;
  }
}
</style>
